import { Component, Listen, Query } from '@atomify/core';
import { debounce } from '@bpd-library/utilities';
import { elements } from '@source/utilities/dom';

const CTA_ACTIVE_CLASS = 'house-characteristics-cta-bar--is-active';
const CTA_BODY_CLASS = 'has--house-characteristics-cta-bar';

@Component({
    tag: 'bpd-house-characteristics-cta-bar',
})
export class HouseCharacteristicsCtaBar extends HTMLElement {
    @Query('[js-hook-characteristics-section]', document) characteristicsSection: HTMLElement;

    @Listen('scroll', { target: window })
    onScroll() {
        debounce(() => {
            this.setActiveClass();
        }, 200)();
    }

    componentDidLoad() {
        this.setBodyClass();
        this.setActiveClass();
    }

    setBodyClass() {
        elements.body.classList.add(CTA_BODY_CLASS);
    }

    setActiveClass() {
        const action =
            window.pageYOffset >
            this.characteristicsSection.offsetTop + this.characteristicsSection.clientHeight
                ? 'add'
                : 'remove';
        this.classList[action](CTA_ACTIVE_CLASS);

        elements.body.classList[action](CTA_ACTIVE_CLASS);
    }
}
